























    import { Vue, Component, Mixins } from 'vue-property-decorator';

	import TextHeader from '@/components/Common/TextHeader.vue';
	import IconPdf from '@/components/Icons/IconPdf.vue';
    import BaseComponent from "@/plugins/BaseComponent";
    import { Controller} from "@/plugins/Controller";
    import {Endpoints} from "@/plugins/endpoints";

    import SliderControl from "@/components/Common/SliderControl.vue";

    import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
    import 'hooper/dist/hooper.css';
    import ModalWindow from "@/components/Common/ModalWindow.vue";

    @Component({
		components: {
		    TextHeader,
			IconPdf,
            Hooper,
			Slide,
            HooperPagination,
			SliderControl,
            ModalWindow,
        }
	})
	export default class Reviews extends Mixins(BaseComponent) {
	    private items: any[] = [];
	    private controller: Controller = new Controller();
        private activeImage: string = "";
        private dialogVisible: boolean = false;
	    private currentSlide: number = 0;

	    mounted(){
	        this.showLoader();
	        this.controller.GetReviews()
				.then(this.gotData)
				.catch(this.hideLoader)
		}

		gotData(response:any){
	        this.hideLoader()
			this.items = response?.data;
	        console.log(response);
		}

        showImage(item:any){
	        let data = JSON.parse(item.value.File);
            this.activeImage = Endpoints.File_Download(data.id);
            this.dialogVisible = true;
		}

		getUrl(item: any){
            let data = JSON.parse(item.value.File);
            return Endpoints.File_Download(data.id);
		}

		navigate(index: number){
			(this.$refs.hooper as any).slideTo(index);
		}

		slideHandler(event: any){
	        this.currentSlide = event.currentSlide;
		}
	}
